import React from "react";

import { Flex, Text } from "@chakra-ui/react";

export const Group = ({ mt, title, children, minHeight, border }) => {
  return (
    <Flex
      mt={mt ? mt : "15px"}
      flexDir="column"
      w="100%"
      minHeight={`${minHeight}`}
      bgColor="#FFF"
      padding={{ base: "5px", sm: "15px" }}
      borderRadius="20px"
      border={border ? border : ""}
    >
      <Text
        fontWeight={700}
        fontSize="16px"
        lineHeight="19.6px"
        whiteSpace="break-spaces"
        color="#169499"
      >
        {title.toUpperCase()}
      </Text>
      {children}
    </Flex>
  );
};
